import { render, staticRenderFns } from "./BpCustomColorLogo.vue?vue&type=template&id=557ce8d1&"
import script from "./BpCustomColorLogo.vue?vue&type=script&lang=js&"
export * from "./BpCustomColorLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports